import React from 'react';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import TextArea from '../components/forms/TextArea';

class ReasonFields extends React.Component {
  render() {
    const {
      translate,
      orderUncompletedCancelledReasonText,
      handleChange,
    } = this.props;

    return (
      <div>
        <h3 className="table-body-text-padding">
          {translate('service_installation.select_reason_title')}
        </h3>
        <div className="row">
          <div className="col-sm-8 col-md-offset-2">
            <TextArea
              name="orderUncompletedCancelledReasonText"
              value={orderUncompletedCancelledReasonText}
              onChange={handleChange}
              rows={3} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentLanguage: getActiveLanguage(state.locale).code,
  translate: getTranslate(state.locale),
  session: state.session,
});

export default connect(
  mapStateToProps,
  null,
)(ReasonFields);



// WEBPACK FOOTER //
// ./src/views/ReasonFields.js